// Import packages
import React, {useEffect, useState} from 'react';
import {
    NavLink, useLocation
} from 'react-router-dom';
import {connect, useDispatch, useSelector} from "react-redux";
import {Accordion, useAccordionButton} from "react-bootstrap";

import {
    AgentsIcon,
    AIIcon,
    AnonymousMenuIcon,
    BuildingsIcon,
    CatalogueMenuIcon, IntegrationsIcon, ListIcon, LockIcon,
    ManageMenuIcon, NotesIcon,
    OpenMenuIcon, PersonIcon, PlayBoxIcon, RolesIcon, SecretopusMascotIcon, ShevronTopIcon, VideoIcon,
    VideoMenuIcon
} from "../../../image";
import './menu.scss';
// Import Utils
import {history} from "../../../utils/history";
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {
    GetUserById,
    GetUserProfile,
    LogOut,
    SetIsFullWidth,
    GetPersonById,
    ClearProfile,
    SetUserAvatar, GetOutlookAuth, UpdateExtensionStatusService, updateActiveMenuService
} from "../../../redux/actions";
import {generateMediaUrl} from "../../../utils/generateMediaUrl";
import {useTranslation} from "react-i18next";
import {detectExtensionPromise, getAuthorName, hasPermission} from "../../../utils/helperFunctions";
import {Popover, Tooltip} from "antd";
import {ROUTERS_MAP} from "../../../utils/routes";
import {ROLE_ITEMS, roleTooltipText} from "../../../utils/constants";
import {objectToQueryString} from "../../../utils/api";
import {CONTENT_TYPE} from "../../../pages/Notes/helpers";
import classNames from 'classnames';
import {Text} from "../../../modules";
import GetStartedItem from "../../../modules/Tour/components/GetStartedItem/GetStartedItem";

const MenuId = ['ai-teams','videos','manage-data','notes', 'users','roles'];
function Menu({
                  LogOut,
                  GetUserProfile,
                  userProfile,
                  GetUserById,
                  userById,
                  isFullWidth,
                  SetIsFullWidth,
                  GetPersonById,
                  userRoles,
                  ClearProfile,
                  SetUserAvatar,
                  userAvatar,
                  GetOutlookAuth
              }) {
    const location = useLocation()
    const {t, i18n} = useTranslation();
    const activeMenuId = useSelector(state => state.utils.activeMenuId);
    const isShowProfilePopup = useSelector((state) => state.tour.isShowProfilePopup);
    const channels = useSelector(state => state?.channels?.channels || []);
    const [activeTab, setActiveTab] = useState(activeMenuId);

    const sortChannels = channels.sort((a) => {
        if (a?.is_private) return -1;
        return 1
    }).sort((a) => {
        if (a.name === 'Личное' || a?.name === 'Personal' || a?.name === "Private") return -1;
        return 1
    });
    const dispatch = useDispatch();

    const [hoverIcon, setHoverIcon] = useState(false);
    useEffect(() => {
        const findId = MenuId.findIndex((item) => location.pathname.includes(item));
        setActiveTab([String(findId)]);
        // dispatch(updateActiveMenuService(String(findId)));
        GetUserProfile().then(async (res) => {
            const status = await detectExtensionPromise();

            UpdateExtensionStatusService({
                status,
                user_id:res?.id,
                notification_status: false
            })
            res?.attached_person?.id && GetPersonById(res?.attached_person?.id, true).then((res) => {
                SetUserAvatar(res?.avatar)
            })
        })
    }, []);

    useEffect(() => {
        GetUserById(userProfile?.id);
        GetOutlookAuth();
    }, [userProfile?.id])

    const logOut = async () => {
        localStorage.setItem('logout', 'true');
        await LogOut()
        history.push(ROUTERS_MAP.LOGIN);
        ClearProfile()
    }

    function CustomToggle({children, eventKey,className}) {
        const decoratedOnClick = useAccordionButton(eventKey, () =>
            {
                dispatch(updateActiveMenuService(activeTab?.includes(eventKey) ? [...activeMenuId].filter((item) => item !== eventKey) : [...activeMenuId,...eventKey]));
                setActiveTab(activeTab?.includes(eventKey) ? [...activeMenuId].filter((item) => item !== eventKey) : [...activeMenuId,...eventKey]);
            }
        );

        return (
            <ShevronTopIcon
                className={`${className || ''} ${(activeTab || []).includes(eventKey) ? 'active' : ''} `}
                onClick={eventKey ? decoratedOnClick : null}
            />
        );
    }
    const ITEMS = [
        {
            id: '0',
            activeText: 'ai-teams',
            main: {
                link: ROUTERS_MAP.COPILOT,
                fullIcon: <AIIcon />,
                title: t('ai_teams')
            },
            child: [
                {
                    id: 0,
                    link: ROUTERS_MAP.COPILOT,
                    title: 'Copilot',
                    icon: <SecretopusMascotIcon/>
                },
                {
                    id: 1,
                    link: ROUTERS_MAP.AI_AGENTS,
                    title: t('agents_menu_title'),
                    icon: <AgentsIcon/>
                }
            ]
        },
        {id: "1"},
        {
            id: '2',
            activeText: 'notes',
            main: {
                link: ROUTERS_MAP.NOTES,
                search: objectToQueryString({personId: userProfile?.attached_person?.id, contentType: CONTENT_TYPE.ACTIONS_ITEMS}),
                fullIcon: <NotesIcon />,
                title: t('notes'),
            },
        },
        {
            id: '3',
            activeText: 'integrations',
            main: {
                link: ROUTERS_MAP.INTEGRATIONS,
                fullIcon: <IntegrationsIcon />,
                title: t('integrations'),
            },
            child: []
        },
        {
            id: '4',
            activeText: 'manage-data',
            main: {
                link: ROUTERS_MAP.MANAGE_DATA,
                fullIcon: <ListIcon/>,
                title: t('menu_item_manage_data')
            },
            child: [
                {
                    id: 0,
                    link: ROUTERS_MAP.MANAGE_DATA,
                    title: t('menu_item_artifacts'),
                    icon: <ManageMenuIcon/>
                },
                {
                    id: 1,
                    link: ROUTERS_MAP.CHANNELS,
                    title: t('menu_item_channels'),
                    icon: <VideoMenuIcon/>
                },

            ]
        },
        {
            id: '5',
            activeText: 'users',
            main: {
                link: ROUTERS_MAP.USERS_LIST,
                fullIcon: <PersonIcon/>,
                title: t('menu_item_persons')
            },
            child: [
                {
                    id: 0,
                    link: ROUTERS_MAP.USERS_LIST,
                    title: t('menu_item_catalogue'),
                    icon: <CatalogueMenuIcon/>
                },
                {
                    id: 1,
                    link: ROUTERS_MAP.USERS_NEW_LIST,
                    title: t('menu_item_anonymous'),
                    icon: <AnonymousMenuIcon/>
                },

            ]
        },
        {
            id: '6',
            activeText: 'roles',
            main: {
                link: ROUTERS_MAP.ROLES,
                fullIcon: <RolesIcon />,
                title: t('menu_item_roles'),
            },
            child: []
        }
    ];

    const [open, setOpen] = useState(false);

    function handleProfileOpenChange(newOpen) {
        setOpen(newOpen)
        // dispatch(UpdateOpenProfilePopup(newOpen))
    }

    const RenderItem = ({data}) => {
        const {id,activeText, main,child} = data;
        return (
            <Accordion.Item
                eventKey={id}
                className={classNames(
                    'sub_menu',
                    {
                        'small-menu': !isFullWidth
                    }
                )}
                id={`menu-item-${id}`}
            >
                <div
                    className={classNames(
                        'menu_item',
                        {
                            'active_menu': location.pathname.includes(activeText),
                            'small-menu': !isFullWidth
                        }
                    )}
                >
                    <NavLink
                        to={main.link}
                        search={main?.search}
                        className="menu_link"
                        activeClassName="active_link"
                        onClick={()=>dispatch(updateActiveMenuService(id))}
                        exact
                    >
                        {isFullWidth ?
                            <>
                                <>{main.fullIcon}</>
                                {isFullWidth && <p>{main.title}</p>}
                            </>
                            :
                            <Tooltip placement="right" title={main.title}>
                                {main.fullIcon}
                            </Tooltip>
                        }
                    </NavLink>
                    <CustomToggle eventKey={id}  className={
                        classNames({
                            'menu_item--shevron-default': !child?.length,
                            'menu_item--shevron': child?.length
                        })
                    }/>
                </div>
                {child?.length ?
                    <Accordion.Body>
                        {child?.map((item)=>(
                            <NavLink
                                to={item.link}
                                className="menu_link menu__sub_item"
                                activeClassName="active_link"
                                onClick={()=>dispatch(updateActiveMenuService(id))}
                                exact
                            >
                                {isFullWidth
                                    ? <>{item.title}</>
                                    :
                                    <Tooltip placement="right" title={item.title}>
                                        {item.icon}
                                    </Tooltip>
                                }
                            </NavLink>
                        ))}
                    </Accordion.Body>
                : null}
            </Accordion.Item>
        )
    }

    return (
        <div className={`menu ${!isFullWidth ? 'small' : ''}`}>
            <div className="">
                {isFullWidth ?
                    <div className={`menu__logo ${!isFullWidth ? 'small-menu' : ''}`}>
                        <span onClick={() => history.push(ROUTERS_MAP.COPILOT)}>{t('secretopus_name')}</span>
                        {isFullWidth && <button className="open-menu" onClick={() => {
                            SetIsFullWidth(!isFullWidth)
                        }}>
                            <OpenMenuIcon/>
                        </button>}
                    </div>
                    : <button className={`open-menu menu__logo ${!isFullWidth ? 'small-menu' : ''}`}
                              onMouseOver={() => setHoverIcon(true)}
                              onMouseLeave={() => setHoverIcon(false)}
                              onClick={() => {
                                  SetIsFullWidth(!isFullWidth)
                              }}>
                        {!hoverIcon ? <span className={''}>
                            {t('secretopus_name')?.slice(0, 1)}
                        </span> :
                            <Tooltip placement="right" title={t('menu_open')}>
                                <OpenMenuIcon/>
                            </Tooltip>
                        }
                    </button>}

                <Accordion defaultActiveKey={activeMenuId} activeKey={activeMenuId}>
                    {ITEMS.map((item)=>{
                        if(item?.id === "1"){
                            return (
                                <Accordion.Item eventKey="1" className={`sub_menu ${!isFullWidth ? 'small-menu' : ''}`}>
                                    <div
                                        className={`menu_item ${location.pathname.includes('videos') ? 'active_menu' : ''} ${!isFullWidth ? 'small-menu' : ''}`}>
                                        <NavLink
                                            to={`/dashboard/videos/review`}
                                            className="menu_link"
                                            activeClassName="active_link"
                                            onClick={()=>dispatch(updateActiveMenuService('1'))}

                                            exact>
                                            {isFullWidth ? <>
                                                    <VideoIcon/>
                                                    {isFullWidth && <p>{t('menu_item_knowledge')}</p>}
                                                </> :
                                                <Tooltip placement="right" title={t('menu_item_knowledge')}>
                                                    <VideoIcon/>
                                                </Tooltip>
                                            }
                                        </NavLink>
                                        <CustomToggle eventKey="1" className="menu_item--shevron"/>
                                    </div>
                                    <Accordion.Body className="channels custom-scroll">
                                        <NavLink
                                            to={`/dashboard/videos/review`}
                                            className="menu_link menu__sub_item"
                                            activeClassName="active_link"
                                            onClick={()=>dispatch(updateActiveMenuService('1'))}
                                            exact
                                        >
                                            <div className="menu__sub_item--wrap">
                                                    <PlayBoxIcon
                                                        style={{marginLeft: '-4px'}}
                                                        className="menu__sub_item--wrap-icon"/>
                                                {isFullWidth ? <span>All</span> : null}
                                            </div>
                                        </NavLink>
                                        {sortChannels.map((item) => (
                                            <NavLink
                                                key={item?.id}
                                                onClick={()=>dispatch(updateActiveMenuService('1'))}
                                                to={{
                                                    pathname: `${ROUTERS_MAP.CHANNEL}/${item.id}`,
                                                    state: {
                                                        routs: [
                                                            {
                                                                path: ROUTERS_MAP.KNOWLEDGE_DATA,
                                                                name: t('menu_item_knowledge')
                                                            }
                                                        ]
                                                    }
                                                }

                                                }
                                                className="menu_link menu__sub_item"
                                                activeClassName="active_link"
                                                exact
                                            >
                                                {isFullWidth ?
                                                    <Tooltip placement="right" title={item?.name}>
                                                        <div className="menu__sub_item--wrap">
                                                            {item?.is_private ?
                                                                <LockIcon
                                                                    style={{marginLeft: '-4px'}}
                                                                    className="menu__sub_item--wrap-icon"/> : null}
                                                            <span>{item?.name}</span>
                                                        </div>
                                                    </Tooltip>
                                                    :
                                                    <Tooltip placement="right" title={item?.name}>
                                                        <div className="menu__sub_item--wrap">
                                                            {item?.is_private ? <LockIcon className="menu__sub_item--wrap-icon"/> :

                                                                <div className="menu__sub_item--wrap">
                                                                    {item?.is_private ?
                                                                        <LockIcon className="menu__sub_item--wrap-icon"/> :
                                                                        <span className="menu__sub_item-dot">
                                                              {(item?.name || '')}
                                                          </span>
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                    </Tooltip>
                                                }

                                            </NavLink>
                                        ))}
                                    </Accordion.Body>
                                </Accordion.Item>
                            )
                        }else if(item.id === '6' && hasPermission(ROLE_ITEMS.ROLES_READ)){
                            return <RenderItem data={item}/>
                        }else if(item.id !== '6'){
                            return <RenderItem data={item}/>
                        }
                    }
                    )}
                </Accordion>
            </div>
            <div className="bottom-part">
                <Popover
                    arrow={false}
                    trigger='click'
                    destroyOnHidden
                    placement="topRight"
                    overlayClassName='popover_menu-profile'
                    getPopupContainer={()=>document.querySelector('.ant-layout')}
                    open={open}
                    onOpenChange={handleProfileOpenChange}
                    content={
                        <>

                            <Text
                                size="f14"
                                font="book"
                                className="menu-item log-out"
                                onClick={() => {
                                    history.push(ROUTERS_MAP.PROFILE);
                                }}
                            >
                                {t('profile_profile')}
                            </Text>
                            <GetStartedItem openPopup={open} isShowProfilePopup={isShowProfilePopup} handleProfileOpenChange={handleProfileOpenChange}/>
                            <Text size="f14" font="book" className="menu-item log-out" onClick={logOut} color="red">{t('profile_log_out')}</Text>
                        </>
                    }
                >
                    <div className={`menu__user-content`}>
                        <img src={generateMediaUrl(userAvatar)} alt=""/>
                        {isFullWidth && <div className="inner">
                            <div className="name">
                                {getAuthorName(userProfile?.attached_person?.id ? userProfile?.attached_person : userById, null, i18n.language)}
                            </div>
                            <div className="company">
                                <BuildingsIcon/>
                                <span>{userProfile?.company?.name}</span>
                            </div>
                            {!!userProfile?.roles?.length &&
                                <div className="user">{userProfile?.roles?.[0]?.name}</div>}
                        </div>}
                    </div>
                </Popover>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'isMobile',
        'userById',
        'personById',
        'userProfile',
        'isFullWidth',
        'userRoles',
        'userAvatar',
    ])
};

const mapDispatchToProps = {
    LogOut,
    GetUserById,
    GetUserProfile,
    SetIsFullWidth,
    GetPersonById,
    ClearProfile,
    GetOutlookAuth,
    SetUserAvatar
};

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
